// Shared ApexCharts base options for dashboard chart widgets (see
// custom-dashboard-widgets design.md Decision 6 / task 5.4). Consumed by
// apex_chart_controller.js only when a chart opts in via
// data-apex-chart-dashboard-value="true" — Percurso's existing charts
// (refactor-percurso-detail-screen) keep their current look untouched.
//
// Brand purple palette (light accent #6246D6 / dark accent #7553FF, see
// config/tailwind.config.js `dashboard`/`dashboard-dark`) — without an
// explicit `colors` array ApexCharts falls back to its own default blue,
// off-theme against the rest of the widget shell.
export const DASHBOARD_CHART_COLORS = [ "#6246D6", "#D19A00", "#D6238E", "#1E7A62", "#9C90AB" ]

export const DASHBOARD_CHART_BASE_OPTIONS = {
  chart: {
    background: "transparent",
    toolbar: { show: false }
  },
  colors: DASHBOARD_CHART_COLORS,
  stroke: {
    curve: "straight"
  },
  markers: {
    size: 0
  },
  legend: {
    show: false
  }
}

// The gradient fade (opacity 0.35 -> 0.05) reads as a soft area-under-line
// fill for `line`/`area` charts — the same look as the Sentry reference this
// theme was matched against. Applied to `bar`/`pie`/`donut` instead, it fades
// the shape to near-invisible (no line to anchor the gradient's "top"), which
// is why every dashboard widget rendered as a barely-visible gray smear until
// this was made conditional on chart type — every current widget service
// returns `type: 'bar'`, so gradient fill was silently breaking 100% of them.
export function fillFor(type) {
  return [ "line", "area" ].includes(type)
    ? { type: "gradient", gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05 } }
    : { type: "solid", opacity: 1 }
}
